import { projectBudgetSynthesis } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectBudgetSynthesis({ uuid }, d) {
      const req = getState().find(
        ({ project, date }) => project.uuid === uuid && d === date,
      );

      return req ? req.synthesis : projectBudgetSynthesis;
    },
    isRetrieveProjectBudgetSynthesisRequestFailure({ uuid }, d) {
      const req = getState().find(
        ({ project, date }) => project.uuid === uuid && d === date,
      );

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectBudgetSynthesisRequestPending({ uuid }, d) {
      const req = getState().find(
        ({ project, date }) => project.uuid === uuid && d === date,
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectBudgetSynthesisRequestSuccess({ uuid }, d) {
      const req = getState().find(
        ({ project, date }) => project.uuid === uuid && d === date,
      );

      return req ? req.request.isSuccessful : false;
    },
    hasRetrievedProjectBudgetSynthesis({ uuid }, d) {
      const req = getState().find(
        ({ project, date }) => project.uuid === uuid && d === date,
      );

      return req ? req.request.isSuccessful || req.request.isFailure : false;
    },
  };
}

export { createSelector };
